if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        const parent = this;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        this.variantPicker = this.closest("product-info")?.querySelector("variant-selects");
        this.includedProduct = this.closest("product-info")?.querySelector("product-included-products");
        let formData = {};
        if(this.variantPicker && this.includedProduct){
          const selectedVariant = this.variantPicker.querySelector("[data-selected-variant]").innerHTML;
          if(selectedVariant){
            const includedProducts = this.includedProduct.querySelectorAll(`input[data-name='${JSON.parse(selectedVariant).id}']`);
            if(includedProducts.length){
              let jsondata = JSON.parse(selectedVariant); 
              let engravingText = "";
              if(jsondata.option2?.includes("Yes") || jsondata.option3?.includes("Yes") && !jsondata.option1?.includes('No Sleeve')){
                engravingText = document.querySelector("#input.txt_input")?.value;
              }
              const items = [];
              includedProducts.forEach(e=>{
                let finalEngravingText = "";
                if(e.name?.includes("Yes")){
                  finalEngravingText = engravingText;
                }
                items.push({
                  id: Number(e.value),
                  quantity: this.closest("product-info")?.querySelector('input[name="quantity"]') ? this.closest("product-info")?.querySelector('input[name="quantity"]').value : 1,
                  properties: {
                    'Engraving Text': finalEngravingText
                  }
                })
              })
              formData['items'] = items;
              if (this.cart) {
                formData['sections'] = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : "";
              }
              formData['sections_url'] = window.location.pathname;
              this.cart.setActiveElement(document.activeElement);
              config.body = JSON.stringify(formData);
            }else {
              delete config.headers['Content-Type'];
              formData = new FormData(this.form);
              if (this.cart) {
                formData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }
              config.body = formData;
            }
          } 
        }else {
          delete config.headers['Content-Type'];
          formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: this.form.querySelector('[name="id"]').value,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: this.form.querySelector('[name="id"]').value,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
